// extracted by mini-css-extract-plugin
export var cellular = "cellular-module--cellular--1rlHX";
export var right = "cellular-module--right--7EmZK";
export var headline = "cellular-module--headline--3l-8v";